import React, { useState, useEffect } from "react";
import { generateMsg, sendMsgToTgChat } from "../misc/telegram.js";
import {
  Form,
  Button,
  InputGroup,
  FloatingLabel,
  Alert
} from "react-bootstrap";
import DatePicker from "./DatePicker";
function PayForm() {
  const [carPlate, setCarPlate] = useState(""); //для номера машины
  const [errorMsg, setErrorMsg] = useState(""); //для общих ошибок на форме
  const [range, setRange] = useState(""); // даты аренды строкой
  const [plateDisabled, setPlateDisabled] = useState(false); // флаг, если в адресе был номер авто
  const [rentDays, setRentDays] = useState(1); // суток аренды, числом
  const [validated, setValidated] = useState(false); // для проверки формы на заполненность-
  const TERMINAL = process.env.REACT_APP_TERMINAL; // tinkoff shop id

  // если в адресной строке передали параметр номера авто, то можно его сразу поставить куда надо и задизейблить ?carPlate=B333BB178
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const plate = params.get("carPlate");
    if (plate !== null && plate.length > 7) {
      setCarPlate(plate);
      setPlateDisabled(true);
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, []);
  //из пикера получаем разницу в днях между стартом и финишем, не меньше 1
  const handleDateSelection = ([dates, start, end]) => {
    if (dates <= 1 || !Number.isInteger(dates)) {
      setRentDays(1);
    } else setRentDays(dates);
    setRange(
      new Date(start).toLocaleDateString() +
        "-" +
        new Date(end).toLocaleDateString()
    );
  };
  //  Обработчик отправки формы
  const handleFormSubmit = e => {
    e.preventDefault();
    clearErrors();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true); // проверяем что все поля заполнены
      setErrorMsg("Заполните все данные!");
      return;
    }

    const email = form.email.value;
    const amount = form.amount.value;
    const mileage = form.mileage.value;
    const phone = form.phone.value;
    const description = form.description.value || "Оплата аренды";

    if (amount && email && phone) {
      form.receipt.value = JSON.stringify({
        Email: email,
        Phone: phone,
        EmailCompany: "mail@mail.com",
        Taxation: "usn_income_outcome",
        Items: [
          {
            Name: `${description} ${carPlate} ${range} пробег ${mileage}`,
            Price: amount + "00",
            Quantity: 1.0,
            Amount: amount + "00",
            PaymentMethod: "full_prepayment",
            PaymentObject: "service",
            Tax: "vat5",
            ShopCode: "TBD"
          }
        ]
      });
      // alert(generateMsg(form.receipt.value))
      sendMsgToTgChat(generateMsg(form.receipt.value))
      // console.log(form.receipt.value);
      // eslint-disable-next-line no-undef
       pay(form);
    } //else alert("Не все обязательные поля заполнены");
    // setErrorMsg('Ошибка при отправки формы!')
    return false;
  };

  // небольшая функция для очистки ошибок при вводе новых данных
  const clearErrors = () => {
    setErrorMsg("");
    setValidated(false);
  };
  //jsx
  return (
    <div>
      <Form
        name="TinkoffPayForm"
        onSubmit={handleFormSubmit}
        validated={validated}
        noValidate
      >
        {errorMsg.length !== 0 && <Alert variant="danger">{errorMsg}</Alert>}
        {/* hidden fields  */}
        <Form.Group>
          <input
            className="tinkoffPayRow"
            type="hidden"
            name="terminalkey"
            value={TERMINAL}
          />
          <input
            className="tinkoffPayRow"
            type="hidden"
            name="frame"
            value="false"
          />
          <input
            className="tinkoffPayRow"
            type="hidden"
            name="language"
            value="ru"
          />
          <input
            className="tinkoffPayRow"
            type="hidden"
            placeholder="Номер заказа"
            name="order"
          />
          <input
            className="tinkoffPayRow"
            type="hidden"
            placeholder="ФИО плательщика"
            name="name"
          />
          <input
            className="tinkoffPayRow"
            type="hidden"
            placeholder="Описание заказа"
            name="description"
          />
          <input
            className="tinkoffPayRow mb-3"
            type="hidden"
            name="receipt"
            value=""
          />
        </Form.Group>
        <Form.Group className="mb-3">
          {/* <Form.Label>Гос номер</Form.Label> */}
          <FloatingLabel label="Гос. номер авто">
            <Form.Control
              type="text"
              placeholder="A000AA178"
              id="carPlate"
              name="carPlate"
              maxLength={9}
              minLength={7}
              disabled={plateDisabled}
              value={carPlate}
              onChange={e => setCarPlate(e.target.value)}
              required
            />
            <Form.Text className="text-muted">
              Без RUS в конце
              {/* {carPlate} */}
            </Form.Text>
          </FloatingLabel>
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Период аренды</Form.Label>
          {/* <Form.Control type="date" placeholder="1000" required/> */}
          <DatePicker handleDateSelection={handleDateSelection} />
          <Form.Text className="text-muted">Суток аренды {rentDays}</Form.Text>
        </Form.Group>

        <Form.Group className="mb-3">
          {/* <Form.Label>Сумма платежа, руб.</Form.Label> */}
          <InputGroup hasValidation className="d-block">
            <FloatingLabel label="Сумма оплаты">
              <Form.Control
                type="number"
                inputMode="numeric"
                placeholder="1000"
                required
                id="summ"
                // value={amount}
                min={100}
                onChange={clearErrors}
                name="amount"
                className="tinkoffPayRow"
              />
              <Form.Control.Feedback type="invalid">
                Cумма оплаты не может быть меньше 100р
              </Form.Control.Feedback>
            </FloatingLabel>
          </InputGroup>
        </Form.Group>
        <Form.Group className="mb-3">
          {/* <Form.Label>Пробег, км</Form.Label> */}
          <InputGroup hasValidation className="d-block">
            <FloatingLabel label="Пробег">
              <Form.Control
                type="number"
                inputMode="numeric"
                placeholder="99999"
                min={0}
                required
                onChange={clearErrors}
                name="mileage"
              />
              <Form.Control.Feedback type="invalid">
                Пожалуйста, введите пробег в км
              </Form.Control.Feedback>
            </FloatingLabel>
          </InputGroup>
        </Form.Group>

        <Form.Group className="mb-3">
          {/* <Form.Label>Почта</Form.Label> */}
          <InputGroup hasValidation className="d-block">
            <FloatingLabel label="E-mail">
              <Form.Control
                className="tinkoffPayRow"
                type="email"
                inputMode="email"
                placeholder="E-mail"
                onChange={clearErrors}
                name="email"
                required
              />
              <Form.Control.Feedback type="invalid">
                Пожалуйста, введите корректный email
              </Form.Control.Feedback>
            </FloatingLabel>
          </InputGroup>
        </Form.Group>
        <Form.Group className="mb-3 w-100">
          {/* <Form.Label>Телефон</Form.Label> */}
          <InputGroup hasValidation className="d-block">
            <FloatingLabel label="Телефон">
              <Form.Control
                className="tinkoffPayRow"
                type="tel"
                inputMode="tel"
                placeholder="Контактный телефон"
                onChange={clearErrors}
                name="phone"
                required
              />
              <Form.Control.Feedback type="invalid">
                Пожалуйста, введите телефон
              </Form.Control.Feedback>
            </FloatingLabel>
          </InputGroup>
        </Form.Group>
        <Button variant="success" type="submit" className="w-100 mb-3">
          Оплатить
        </Button>
      </Form>
    </div>
  );
}

export default PayForm;
